import app from "@/main";
import { _axios } from "@/plugins/axios";
import { store } from "@/_store";
import { vuetify } from "@/plugins/vuetify";

//TODO  parametrizar isto!!
export function getApiBaseUrl() {
  let props = {
    location:
      process.env.NODE_ENV === "production"
        ? window.location.protocol + "//" + window.location.hostname
        : process.env.VUE_APP_URL,
    port: process.env.NODE_ENV === "production" ? "" : ":8000",
    api_root: process.env.VUE_APP_API_ROOT,
  };

  return props.location + props.port + props.api_root;
}

export function getApiUrl(service_path) {
  if (!service_path) {
    service_path = "";
  }
  service_path = "clapp/" + service_path;

  return service_path;
}

export function getApiAuthToken() {
  return "rest-auth/obtain_token/";
}

export function getApiRefreshAuthToken() {
  return "rest-auth/refresh_token/";
}

export function apiFetch(service_path) {
  const requestOptions = {
    method: "GET",
    url: getApiUrl(service_path),
  };

  //Inspirado em https://blog.pusher.com/promises-async-await/
  let p_apiFetch = new Promise((resolve, reject) => {
    _axios(requestOptions).then(
      (result) => {
        app.$log.debug("API URL:", getApiUrl(service_path));
        app.$log.debug("API CALL:", result.data);
        resolve(result.data);
      },
      (error) => {
        app.$log.warn(error);
        reject(error);
      },
    );
  });

  return p_apiFetch;
}

export function apiPost(service_path, data) {
  const requestOptions = {
    method: "POST",
    url: getApiUrl(service_path),
    data: data,
  };

  //Inspirado em https://blog.pusher.com/promises-async-await/
  let p_apiPost = new Promise((resolve, reject) => {
    _axios(requestOptions).then(
      (result) => {
        app.$log.debug("API POST URL:", getApiUrl(service_path), data);
        app.$log.debug("API POST CALL:", result.data);
        resolve(result.data);
      },
      (error) => {
        app.$log.warn(error);
        reject(error);
      },
    );
  });

  return p_apiPost;
}

export function getUrlParams(url) {
  let params = {};
  url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    params[key] = value;
  });
  return params;
}

/**
 * A function to deal with the errors obtained after a request. This performs three actions:
 * 1 - uses the Log to display the context where the error occurred
 * 2 - removes the Loading layer
 * 3 - triggers the alert component displaying the error message or a generic error message when the response has no information regarding the error
 * @param error
 * @param context
 * @param ref_object
 */
export function getErrorMessage(error, context) {
  app.$log.debug(context + " | Error");

  store.dispatch("loader/setLoading", false);

  if (error && error.response && error.response.data.status) {
    store.dispatch("alert/error", error.response.data.status);
  } else {
    store.dispatch("alert/error", vuetify.locale.t("$vuetify.generic_error"));
  }
}

export function recaptchaHelper(operation, executeRecaptcha) {
  return new Promise((resolve, reject) => {
    executeRecaptcha(operation).then(
      (token) => {
        resolve(token);
      },
      (error) => {
        if (store.state.configs.recaptchaAvailable) {
          reject(error);
        } else {
          resolve("9999");
        }
      },
    );
  });
}
